import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTag, DocumentTags } from '@app/features/documents/document.model';

@Pipe({
  name: 'documentTagLabel',
  standalone: true,
})
export class DocumentTagLabelPipe implements PipeTransform {
  transform(value: DocumentTag | undefined): string {
    if (!value) {
      return 'Type de document non défini';
    }
    return DocumentTags.labels[value];
  }
}
